import { Component, OnInit, } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { AuthenticationService, MenuService, UserService } from './_services';
import { User } from './_models';
import { interval } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { IndexedDBService } from './_services/indexdDb.service';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from './_shared/loader/loader.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    LoaderComponent
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  currentUser: User = new User();
  title = 'angular-docs-ia';
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private http: HttpClient,
    private userService: UserService,
    private menuService: MenuService,
    public translate: TranslateService,
    private indexedDbService: IndexedDBService
  ) {
    console.log('AppComponent constructor called');
    let storelang = localStorage.getItem("lang") || 'pt';
    if(storelang === null || storelang === "null") {
      storelang = "pt";
      localStorage.setItem("lang", storelang);
    }
    translate.setDefaultLang(storelang);
    this.translate.use(storelang);

    const self = this;
    const minuteTime = interval(60000);
    minuteTime.subscribe((minute: any) => {
      self.userService.updateUSerByToken();
    })

    // Initialize authentication service if not initialized
    if (!self.authenticationService.currentUser) {
      self.authenticationService.inicialize().then(() => {
        self.subscribeToCurrentUser();
      });
    } else {
      self.subscribeToCurrentUser();
    }
  }

  private subscribeToCurrentUser() {
    const self = this;
    self.authenticationService.currentUser?.subscribe((x: any) => {
      self.currentUser = x;
      if ((!self.currentUser && !window.location.search) || (self.authenticationService.currentUserValue && !self.authenticationService.currentUserValue.selectedEmpresa)) {
        self.http.get(environment.baseUrl.replace('/api', '/csrf'), { withCredentials: true }).subscribe((res: any) => {
          // páginas abertas sem sessão (inclusive pelo link do e-mail de redefinição do KTIdentity)
          const publicPaths = ['login', 'changePassword', 'pages/recovery', 'recuperar-senha', 'vincular-identity'];
          if (!publicPaths.some(path => window.location.pathname.includes(path))) {
            self.authenticationService.isLoginSubject.next(false);
            const lang = localStorage.getItem('lang') || 'pt';
            // localStorage.removeItem('currentUser');
            self.indexedDbService.clearStore('userData').then(result =>{console.log(result)})
            localStorage.clear();
            if(lang) {
              localStorage.setItem('lang', lang);
            }
            self.router.navigate([this.authenticationService.currentLoginPathValue]);
          }
        });
      }


    });
  }

  ngOnInit(): void {
    console.log('AppComponent initialized');
    console.log('Current route:', this.router.url);
    console.log('Current user:', this.currentUser);
  }

  logout() {
    this.authenticationService.logout().subscribe((data: any) => {
      this.router.navigate([this.authenticationService.currentLoginPathValue]);
    })

  }
}
